import { TableCard } from '../../../../components'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { FaturaTable } from './table/FaturaTable'
import { FaturaListHeader } from './components/header/FaturaListHeader'

const FaturaList = () => {
  return (
    <TableCard>
      <FaturaListHeader />
      <FaturaTable />
    </TableCard>
  )
}

export const FaturaListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <FaturaList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
